import * as Logger from '../libs/wa-logger';
import * as Helper from "./main-menu-helper"
import * as Guards from "../libs/guards"

const $ = require('jquery');
// function largeMainMenuDropdownItems(enable: boolean) {
// 	const dropdown_menu_items = document.querySelectorAll('.dropdown')

// 	function handleExpand(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		t.classList.add('open')
// 		console.log(["entered", ev])
// 	}
// 	function handleCollapse(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		t.classList.remove('open')
// 		console.log(["leaving", ev])
// 	}
// 	if(enable) {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.addEventListener("mouseenter", handleExpand)
// 			li_el.addEventListener("mouseleave", handleCollapse)
// 		})
// 	} else {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.removeEventListener("mouseenter", handleExpand)
// 			li_el.removeEventListener("mouseleave", handleCollapse)
// 		})
// 	}
// }
// function smallMainMenuDropdownItems(enable: boolean) {
// 	const dropdown_menu_items = document.querySelectorAll('.dropdown')

// 	function handleExpand(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		if(! t.classList.contains('open')) {
// 			t.classList.add('open')
// 			console.log(["entered", ev])
// 		}
// 	}
// 	function handleCollapse(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		if(t.classList.contains('open')){
// 			t.classList.remove('open')
// 			console.log(["leaving", ev])
// 		}
// 	}
// 	if(enable) {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.addEventListener("mouseenter", handleExpand)
// 			li_el.addEventListener("mouseleave", handleCollapse)
// 		})
// 	} else {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.removeEventListener("mouseenter", handleExpand)
// 			li_el.removeEventListener("mouseleave", handleCollapse)
// 		})
// 	}
// }
var selector = ""
var placement = "" 
export function initialize() {
	Logger.log(['main-menu', Helper]);
	const a1 = $('#navbar a');
	if (a1.length === 0) {
		Logger.log('mainMenu - selector not found');
		return;
	}
	const select_non_dropdown_items = '#navbar > li:not(.dropdown) > a:not(.dropdown-toggle)';
	const select_dropdown_button = '#navbar > li.dropdown > a.dropdown-toggle';
	const select_dropdown_items = '#navbar > li.dropdown > ul > li:not(.divider)'
	const select_dropdown_anchors = '#navbar > li.dropdown > ul > li:not(.divider) > a';

	const non_dropdown_items = document.querySelectorAll(select_non_dropdown_items);
	const dropdown_button = document.querySelectorAll(select_dropdown_button);
	const dropdown_items = document.querySelectorAll(select_dropdown_items);
	const dropdown_anchors = document.querySelectorAll(select_dropdown_anchors);

	/** Setup a tooltip for all the main menu items that are NOT dropdown menus */
	selector = select_non_dropdown_items
	placement = "sw"
}
export function handle_media_query(is_small: boolean)
{
	if(is_small) {
		Helper.setup_small(selector)
	} else {
		Helper.setup_big(selector)
	}
}

